const PASSWORD_SYMBOL_RE = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

/** For signup UI checklist — same rules as `validatePasswordPolicy`. */
export function signupPasswordChecks(pw: string): { len: boolean; num: boolean; sym: boolean } {
  return {
    len: Boolean(pw && pw.length >= 8),
    num: /[0-9]/.test(pw),
    sym: PASSWORD_SYMBOL_RE.test(pw),
  };
}

/** 8+ characters, at least one number, at least one symbol — signup, recovery, client checks */
export function validatePasswordPolicy(pw: string): string | null {
  if (!pw || pw.length < 8) return "Use at least 8 characters.";
  if (!/[0-9]/.test(pw)) return "Include a number.";
  if (!PASSWORD_SYMBOL_RE.test(pw)) return "Include a symbol (e.g. ! @ # $).";
  return null;
}

export function validateSignupPassword(pw: string): string | null {
  return validatePasswordPolicy(pw);
}

export function validateEmailFormat(email: string): string | null {
  const t = email.trim();
  if (!t) return "Enter your email.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)) return "Enter a valid email address.";
  return null;
}

/** Password reset / in-app password changes — same policy as signup */
export function validatePasswordRules(pw: string): string | null {
  return validatePasswordPolicy(pw);
}
